import { error } from "@sveltejs/kit";
import frontMatter from "front-matter";

import {
  findChildren,
  findNearestParent,
  findNextPage,
  findPrevPage,
} from "$lib/gpu-glossary";
import type { PageLoad } from "./$types";
import contents from "../contents.json";

const markdownFiles = import.meta.glob("/src/lib/gpu-glossary/**/*.md", {
  eager: true,
  query: "?raw",
  import: "default",
});

export type Metadata = {
  title: string;
  abbreviation?: string;
};

export const prerender = "auto";

export const load: PageLoad = async ({ params }) => {
  const { id: path } = params;

  const fullPath = `/gpu-glossary/${path}`;

  const nextPage = findNextPage({
    currentHref: fullPath,
    pages: contents,
  });

  const prevPage = findPrevPage({
    currentHref: fullPath,
    pages: contents,
  });

  const nearestParent = findNearestParent({
    currentHref: fullPath,
    pages: contents,
  });

  const children = findChildren({
    currentHref: fullPath,
    pages: contents,
  });

  const filePath = `/src/lib/gpu-glossary/${path}.md`;

  const content = markdownFiles[filePath] as string | undefined;

  if (!content) {
    error(404, "Term not found");
  }

  const { attributes: metadata, body } = frontMatter<Metadata>(content);

  return {
    content: body,
    metadata: {
      title: metadata.title,
      abbreviation: metadata.abbreviation,
      path: `/${path}`,
    },
    nextPage,
    prevPage,
    children,
    isTopLevel: nearestParent ? nearestParent.href === "/gpu-glossary" : false,
    title: metadata.title + " | GPU Glossary",
    ogTitle: metadata.title + " | GPU Glossary",
    ogDescription: "",
    description: "",
    ogImageUrl: "https://modal.com/assets/gpu-glossary-og-1.png",
  };
};
